import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventIcon from '@mui/icons-material/Event';
import HistoryIcon from '@mui/icons-material/History';
import MapIcon from '@mui/icons-material/Map';
import StorageIcon from '@mui/icons-material/Storage';
import BuildIcon from '@mui/icons-material/Build';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import TrafficIcon from '@mui/icons-material/Traffic';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import SecurityIcon from '@mui/icons-material/Security';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AppsIcon from '@mui/icons-material/Apps';
import { GlobalContext } from '../GlobalProvider';
import loopwayIcon from '../assets/tn.svg';
const Sidebar = () => {

  const { loginDetails, orgDetails, currentApp } = useContext(GlobalContext); // Access context values
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const toggleUserDrawer = (open) => {
    setIsUserDrawerOpen(open);
  };

  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove token from localStorage
    navigate('/login'); // Redirect to login page
  };

  // If loginDetails is null (e.g., not authenticated), don't render the sidebar
  if (!loginDetails) return null;

  return (
    <>
      {/* Main Sidebar */}
      <Drawer
        variant="permanent"
        anchor="left"
        PaperProps={{ style: { width: '280px' } }} // Adjust the width of the main drawer
      >
        <Toolbar>
          <img
            src={loopwayIcon}
            alt="Asset Icon"
            style={{ width: '50px', height: '50px', marginRight: '10px' }}
          />
          <Typography variant="h5"  sx={{
      background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 700,
      fontFamily: 'Roboto, sans-serif',
      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }} noWrap>
            Apollo
          </Typography>
        </Toolbar>
        <List>
          {!currentApp.adminApp ? <>  <ListItem button component={Link} to="/">
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>

            <ListItem button component={Link} to="/map">
              <ListItemIcon>
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Live Map" />
            </ListItem>
            <ListItem button component={Link} to="/incidents">
              <ListItemIcon>
                <TrafficIcon />
              </ListItemIcon>
              <ListItemText primary="Incidents" />
            </ListItem>
            <ListItem button component={Link} to="/entities">
              <ListItemIcon>
                <TrafficIcon />
              </ListItemIcon>
              <ListItemText primary="Entities" />
            </ListItem>
            <ListItem button component={Link} to="/assets">
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Assets" />


            </ListItem>
            <ListItem button component={Link} to="/events">
              <ListItemIcon>
                <EventIcon />
              </ListItemIcon>
              <ListItemText primary="Events" />
            </ListItem>
            <ListItem button component={Link} to="/actions">
              <ListItemIcon>
                <BuildIcon />
              </ListItemIcon>
              <ListItemText primary="Actions" />

            </ListItem>
            <ListItem button component={Link} to="/workflow">
              <ListItemIcon>
                <SyncAltIcon />
              </ListItemIcon>
              <ListItemText primary="Workflow" />
            </ListItem>

            {/* Crash Data */}
            <ListItem button component={Link} to="/crash-data">
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Crash Data" />
            </ListItem>
          </> : <>
            <ListItem button component={Link} to="/users">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
            <ListItem button component={Link} to="/organizations">
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary="Organizations" />
            </ListItem>
            <ListItem button component={Link} to="/roles">
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Roles" />
            </ListItem>          </>}



        </List>
        <Divider />
        {/* Bottom Menu */}
        <List style={{ marginTop: 'auto' }}>
          <ListItem button component={Link} to="/apps">
            <ListItemIcon>
              <AppsIcon />
            </ListItemIcon>
            <ListItemText primary="Apps" />
          </ListItem>
          <ListItem button onClick={() => toggleUserDrawer(true)}>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={`${loginDetails.firstName} ${loginDetails.lastName}`} />
          </ListItem>
        </List>
      </Drawer>

      {/* User Drawer */}
      <Drawer
        anchor="right"
        open={isUserDrawerOpen}
        onClose={() => toggleUserDrawer(false)}
        PaperProps={{
          style: { width: '400px', padding: '20px', backgroundColor: '#f4f4f4' }, // Adjust width and background color
        }}
      >
        <Toolbar>
          <Typography variant="h6" style={{ flexGrow: 1 }}>

          </Typography>
          <IconButton
            edge="end"
            onClick={() => toggleUserDrawer(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <Box p={3}>
          <Typography variant="h6" gutterBottom>
            Welcome, {loginDetails.firstName} {loginDetails.lastName}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Email:</strong> {loginDetails.email}
          </Typography>
          {orgDetails && (
            <Typography variant="body1" gutterBottom>
              <strong>Organization:</strong> {orgDetails.name}
            </Typography>
          )}
          {currentApp && (
            <Typography variant="body1" gutterBottom>
              <strong>Current App:</strong> {currentApp.name}
            </Typography>
          )}
          <Divider style={{ margin: '20px 0' }} />
          <List>
            <ListItem button onClick={handleLogout}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
